import React, { ReactNode, useState } from "react"
import { Grid, Tooltip, Typography } from "@material-ui/core"

import {
	ReportProblemOutlined as WarningIcon,
	CheckBox as CheckBoxIcon
} from "@material-ui/icons"

import { ActionDialog, Notification } from "@/components"

import ErrorHandlerService from "@/services/ErrorHandler"

import { ErrorType } from "@/hooks/useValidation"

import useStyles from "@/pages/Admin/ClientCatalog/BlockContactDialog/styles"
import { colors } from "@/styles/colors"
import WABAContactService from "@/@integrations/WABA/services/WABAContactService"

type UnblockContactDialogProps = {
	children: ReactNode
	clientId: number
	inboxChannelId: number
	hasTooltip?: boolean
	disabled?: boolean
	onSuccess?: () => void
}

const BlockContactDialog: React.FC<UnblockContactDialogProps> = (props) => {
	const {
		children,
		clientId,
		inboxChannelId,
		hasTooltip,
		disabled,
		onSuccess
	} = props

	const classes = useStyles()

	const [openDialog, setOpenDialog] = useState(false)

	const handleOpenDialog = async () => {
		setOpenDialog(true)
	}

	const handleCloseDialog = () => {
		setOpenDialog(false)
	}

	const handleUnblockContact = async () => {
		try {
			await WABAContactService.unblockWabaContact({
				clientId,
				inboxChannelId
			})
			onSuccess?.()
			handleCloseDialog()
		} catch (error) {
			ErrorHandlerService.handle(error as ErrorType)

			Notification.error({
				message: "Erro ao desbloquear contato."
			})
			handleCloseDialog()
		}
	}

	return (
		<>
			{
				<Tooltip
					title= {hasTooltip ? "Desbloquear contato na WABA." : ""}
				>
					<Grid
						onClick={!disabled && handleOpenDialog}
					>
						{children}
					</Grid>
				</Tooltip>
			}

			<ActionDialog
				fullWidth
				openDialog={openDialog}
				onClose={handleCloseDialog}
				title={"ATENÇÃO"}
				dialogTitleIcon={<WarningIcon className={classes.titleIcon}/>}
				cancelText="CANCELAR"
				onSave={handleUnblockContact}
				saveText="CONFIRMAR"
				dialogTitleClassName={classes.title}
			>
				<Grid
					container
					direction="column"
					spacing={2}
				>
					<Grid
						item
						xs={12}
					>
						<Typography>
                            Ao desbloquear este contato, ele poderá voltar a interagir normalmente! Isso significa que:
						</Typography>
					</Grid>
					<Grid
						item
						xs={12}
					>
						<Grid
							container
							spacing={2}
						>

							<Grid
								item
								xs={12}
							>
								<Grid
									container
									spacing={1}
								>
									<Grid
										item
									>
										<Grid
											container
											alignItems="flex-start"
										>
											<CheckBoxIcon
												style={{
													width: 24,
													height: 24,
													fill: colors.green[500]
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										item
										xs={10}
									>
										<Typography
											variant="h4"
										>
                                            Você poderá enviar e receber mensagens do contato novamente.
										</Typography>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
					<Grid
						item
						xs={12}
					>
						<Typography>
                            Tem certeza de que deseja continuar?
						</Typography>
					</Grid>
				</Grid>
			</ActionDialog>
		</>
	)
}

export default BlockContactDialog
